import axios, { AxiosRequestConfig } from "axios";
import services from "../services";
const BASE_URL = process.env.REACT_APP_API_URL || "/";

interface VerbParamsInterface {
  url: string;
  body?: any;
  config?: AxiosRequestConfig;
}

const getConfig = async (config) => {
  const token = services.auth.getToken() || "";

  return {
    baseURL: BASE_URL,
    ...config,
    ...(token && {
      headers: { authorization: `Bearer ${token}`, ...config.headers },
    }),
  };
};

const Get = async ({ url, config = {} }: VerbParamsInterface) => {
  const defaultConfig = await getConfig(config);
  const { data } = await axios.get(url, { ...defaultConfig });
  return data;
};

const Post = async ({ url, body = {}, config = {} }: VerbParamsInterface) => {
  const defaultConfig = await getConfig(config);
  const { data } = await axios.post(url, body, { ...defaultConfig });
  return data;
};

const Put = async ({ url, body = {}, config = {} }: VerbParamsInterface) => {
  const defaultConfig = await getConfig(config);
  const { data } = await axios.put(url, body, { ...defaultConfig });
  return data;
};

const Del = async ({ url, config = {} }: VerbParamsInterface) => {
  const defaultConfig = await getConfig(config);
  const { data } = await axios.delete(url, { ...defaultConfig });
  return data;
};

const Patch = async ({ url, body = {}, config = {} }: VerbParamsInterface) => {
  const defaultConfig = await getConfig(config);
  const { data } = await axios.patch(url, body, {
    ...defaultConfig,
  });
  return data;
};

const actions = {
  Get,
  Post,
  Put,
  Del,
  Patch,
};

export default actions;
